import { useState } from "react";
import classNames from "classnames";

export const Input = ({
  rowSize = 2,
  showLineNumber = false,
  customStyle = {},
  name,
  error,
  validation,
  rowHasError = false,
  errorMessage = "",
  childHasError,
  columnDataArr,
  value,
  classes,
  tableName = "",
  onClick,
  readonly,
  ...props
}) => {
  const [hasError, setError] = useState(false);
  const [scrollTop, setScrollTop] = useState(0);

  const lineNumbers = (value || "").split("\n");
  const lineCount = Math.max(lineNumbers.length, rowSize);
  const lineHeight = 24;
  const textareaHeight = rowSize * lineHeight;
  const dynamicPaddingLeft = showLineNumber
    ? lineCount <= 99
      ? 38
      : lineCount <= 999
        ? 42
        : 50
    : 8;

  const handleOnChange = (e) => {
    const hasError = validation(e, columnDataArr);
    if (!hasError) {
      childHasError(true);
      setError(true);
    } else {
      childHasError(false);
      setError(false);
    }
    props.onChange(e);
  };

  const handleOnScroll = (e) => {
    setScrollTop(e.target.scrollTop);
  };

  return (
    <>
      <div
        className={classNames(
          classes.inputWrapperDiv,
          `inputWrapperDiv${tableName}`,
        )}
        onClick={onClick}
        style={{
          position: "relative",
          width: "100%",
          height: textareaHeight,
          overflow: "hidden",
        }}
      >
        {showLineNumber && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 15,
              height: textareaHeight,
              paddingTop: 10,
              paddingRight: 6,
              textAlign: "left",
              color: "rgba(0,0,0,0.45)",
              fontSize: "13px",
              lineHeight: `25px`,
              overflow: "hidden",
              pointerEvents: "none",
              zIndex: 10,
              boxSizing: "border-box",
            }}
          >
            <div
              style={{
                transform: `translateY(-${scrollTop}px)`,
                width: "100%",
              }}
            >
              {Array.from({ length: lineCount }, (_, index) => (
                <div key={index} style={{ height: lineHeight }}>
                  {index + 1}
                </div>
              ))}
            </div>
          </div>
        )}
        <textarea
          className={classNames(classes.input, `input${tableName}`)}
          rows={rowSize}
          name={name}
          value={value || ""}
          readOnly={readonly}
          onChange={handleOnChange}
          onScroll={showLineNumber ? handleOnScroll : undefined}
          style={{
            width: "100%",
            height: textareaHeight,
            lineHeight: `${lineHeight}px`,
            boxSizing: "border-box",
            overflowY: "auto",
            overflowX: "hidden",
            ...customStyle,
            paddingLeft: `${dynamicPaddingLeft}px`,
            paddingTop: "6px",
            paddingBottom: "6px",
            paddingRight: "8px",
            backgroundColor: readonly ? "#f4f4f4" : undefined,
            cursor: readonly ? "pointer" : undefined,
          }}
        />
      </div>
    </>
  );
};
